import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCs8q199-DhHuus9vv-nJNcNeKaNSrJh-U',
  authDomain: 'myuser-ai.firebaseapp.com',
  projectId: 'myuser-ai',
  storageBucket: 'myuser-ai.appspot.com',
  messagingSenderId: '411674485024',
  appId: '1:411674485024:web:c2451a66b31240f574b745',
  measurementId: 'G-KZD07WXDD6'
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

export { auth, firebase };
